import bannerImage from '../pages/assets/echohire/banner.png'
import dashboardImage from '../pages/assets/echohire/dashboard.png'
import qrAiBanner from '../pages/assets/qrAi/banner.png'
import qrAiDashboard from '../pages/assets/qrAi/dashboard.png'
import qrAiChat from '../pages/assets/qrAi/chat.png'
import allinolBanner from '../pages/assets/allinol/allinoldash.jpg'
import allinolImage from '../pages/assets/allinol/allinol.jpg'
import allinolDoc from '../pages/assets/allinol/allinoldoc.jpg'

export interface Project {
  id: string
  title: string
  company: string
  period: string
  description: string
  keyFeatures: string[]
  results: string[]
  screenshots: string[]
  process: string[]
  bannerImage: string
  demoVideo?: string
}

export const projectsData: Project[] = [
  {
    id: '1',
    title: 'EchoHire',
    company: 'EchoHire',
    period: '2025 - Present',
    description: 'EchoHire automatically screens candidates with AI — evaluating their communication skills, professionalism, and fluency — so you only meet the best-fit applicants without wasting time.',
    keyFeatures: [
      'AI-powered audio evaluation of candidate responses',
      'Real-time scoring of pronunciation, grammar, and fluency',
      'Automated screening workflow',
      'Focus on top-performing candidates'
    ],
    results: [
      'Reduced screening time by 80%',
      'Improved candidate quality by focusing on communication skills',
      'Streamlined hiring process for recruiters',
      'Data-driven candidate evaluation'
    ],
    screenshots: [
      dashboardImage
    ],
    process: [
      'Step 1: Candidates apply and record audio responses to English proficiency questions',
      'Step 2: AI analyzes and scores pronunciation, grammar, fluency, and communication quality in real-time',
      'Step 3: Review scored candidates and focus interviews on top performers'
    ],
    bannerImage: bannerImage,
    demoVideo: 'https://x.com/0marmdv/status/1935344248754147404?s=20'
  },
  {
    id: '3',
    title: 'Allinol',
    company: 'Allinol',
    period: '2025 - Present',
    description: 'Allinol - AI-Driven Business Automation Platform (MVP STAGE)\nAllinol is a comprehensive business automation platform that centralizes company operations through a cross-platform application, integrating neural networks and third-party services.',
    keyFeatures: [
      'Process Automation Engine: Integration with automation tools',
      'AI-Driven Automation: AI-powered recommendations for workflow optimization',
      'Data & Entity Management: Store, manage, and structure key business data',
      'Documentation & Knowledge Management: AI-assisted document classification and retrieval'
    ],
    results: [
      'Centralized business operations in one platform',
      'Seamless integration with neural networks',
      'Improved workflow efficiency through AI recommendations',
      'Enhanced document management with AI assistance'
    ],
    screenshots: [
      allinolBanner,
      allinolImage,
      allinolDoc
    ],
    process: [
      'Step 1: Integrate existing business tools and services into Allinol platform',
      'Step 2: Configure automation workflows with AI-driven optimization',
      'Step 3: Utilize AI recommendations for process improvements',
      'Step 4: Manage business data with AI-assisted documentation and retrieval'
    ],
    bannerImage: allinolBanner,
    demoVideo: 'https://x.com/0marmdv/status/1905395142741078459?s=20'
  },
  {
    id: '2',
    title: 'qrAi - Exhibition AI Chat',
    company: 'qrAi',
    period: '2025',
    description: 'A sophisticated Progressive Web App (PWA) featuring a dual-mode AI chat system designed to revolutionize visitor engagement at trade shows through two distinct but interconnected web-based experiences.',
    keyFeatures: [
      'Mode 1 - Booth-Specific Chat: AI conversations focused exclusively on individual exhibitor data',
      'Mode 2 - General Event Chat: Comprehensive event assistance with all exhibitor information',
      'QR code-based access for seamless visitor engagement',
      'Dynamic AI context injection for accurate, focused responses'
    ],
    results: [
      'Revolutionized trade show visitor engagement through AI-powered conversations',
      'Provided focused exhibitor-specific interactions without information contamination',
      'Enabled comprehensive event assistance including venue navigation and scheduling',
      'Delivered cross-exhibitor comparisons and discovery capabilities'
    ],
    screenshots: [
      qrAiDashboard,
      qrAiChat
    ],
    process: [
      'Step 1: Visitors scan QR codes at individual booths or event-wide locations',
      'Step 2: AI dynamically injects context-specific data (booth-specific or all-exhibitor)',
      'Step 3: Visitors engage in natural conversations for product info, comparisons, or event logistics',
      'Step 4: AI provides accurate, contextual responses based on the selected interaction mode'
    ],
    bannerImage: qrAiBanner
  }
]